import { Store } from '@ngxs/store';
import { AppConfigState } from '@nibtravel/shared/util/app-config';
import { HttpParams } from '@angular/common/http';

export abstract class BaseApiEndpointService {
  protected constructor(protected store: Store, private api: string) {}

  getApiUrl(): string {
    return this.store.selectSnapshot((state) =>
      AppConfigState.getApiUrl(state.appConfig, this.api)
    );
  }

  protected constructUrl(endpoint: string, httpParams?: HttpParams): string {
    const baseApiUrl = this.store.selectSnapshot((state) =>
      AppConfigState.getApiFullUrl(state.appConfig, this.api)
    );

    return httpParams && httpParams.keys().length > 0
      ? `${baseApiUrl}${endpoint}?${httpParams}`
      : `${baseApiUrl}${endpoint}`;
  }
}
